export default __webpack_public_path__ + "static/media/Shop-13.12de3f39.webp";